import { useState } from 'react'

import { useAssociateCases } from '../../../shared/hooks/useAssociateCases'
import { useTranslation } from 'react-i18next'

import { Box, Button, MultiSelectInput } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface AssociateExisitingCaseFormIProps {
  incidentId: string
  onClose: () => void
  colorScheme?: ColorScheme
}

export const AssociateExisitingCaseForm = ({
  incidentId,
  onClose,
  colorScheme = 'dark',
}: AssociateExisitingCaseFormIProps) => {
  const { t } = useTranslation()
  const { caseOptions, isAssociationLoading, associateIncident } =
    useAssociateCases({ incidentId, onClose })

  const [selectedCases, setSelectedCases] = useState<string[]>([])

  const handleSubmit = () => {
    const cases = selectedCases.map((id) => {
      const opt = caseOptions.find((o: { value: string }) => o.value === id)
      return { value: id, label: opt?.label ?? id }
    })
    associateIncident({ cases })
  }

  return (
    <Box>
      <MultiSelectInput
        colorScheme={colorScheme}
        intentLabel={t('incidents:associate_case_search_cases')}
        maxResults={7}
        noMatchLabel={t('incidents:associate_case_no_results')}
        onClear={() => setSelectedCases([])}
        onRemove={(value) =>
          setSelectedCases((prev) => prev.filter((v) => v !== value))
        }
        onToggleOption={(value) => {
          setSelectedCases((prev) =>
            prev.includes(value)
              ? prev.filter((v) => v !== value)
              : [...prev, value]
          )
        }}
        options={caseOptions}
        placeholder={t('incidents:cases_placeholder')}
        resultsHeader={t('incidents:associate_case_select_cases')}
        searchPlaceholder={t('incidents:associate_case_search_cases')}
        searchable
        selected={selectedCases}
      />

      <Box display='flex' gap='8px' justifyContent='flex-end' mt='16px'>
        <Button colorScheme={colorScheme} onClick={onClose} variant='secondary'>
          {t('common:cancel')}
        </Button>
        <Button
          colorScheme={colorScheme}
          disabled={selectedCases.length === 0}
          isLoading={isAssociationLoading}
          onClick={handleSubmit}
        >
          {t('cases:associate')}
        </Button>
      </Box>
    </Box>
  )
}
